import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';
import {TargetGroup} from 'shared/models/target-groups/target-group';

@Injectable()
export class TargetGroupsListRepository {

  constructor(private http: Http) { }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.targetGroups}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }
}


// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/target-groups-list/repositories/target-groups-list.repository.ts